import { Box, Button, Form, InputField } from '@otovo/rainbow';
import { SyntheticEvent } from 'react';

import { FormattedMessage as T, useIntl } from 'react-intl';

import sharedMessages from '@otovo/shared/components/Translations/messages';

import LoginError from './LoginError';
import { UnauthorizedError } from './hooks/errors/UnauthorizedError';
import m from './messages';

type Props = {
  isLoggingIn: boolean;
  error: Error | null;
  handleLogin: (username: string, password: string) => void;
  handleChange: (arg1: SyntheticEvent<HTMLInputElement>) => void;
};

const LoginForm = ({
  handleChange,
  handleLogin,
  error,
  isLoggingIn,
}: Props) => {
  const intl = useIntl();

  function handleSubmit(event: SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    const { username, password } = event.currentTarget;

    handleLogin(username.value.trim().toLowerCase(), password.value.trim());
  }

  function renderErrorMessage() {
    if (error instanceof UnauthorizedError) {
      return <T {...m.errorMessageUnauthorized} />;
    }

    return <T {...m.errorMessageUserProfile} />;
  }

  return (
    <>
      <Box mb="4">
        {!!error && <LoginError message={renderErrorMessage()} />}
      </Box>
      <div>
        <Form onChange={handleChange} onSubmit={handleSubmit}>
          <InputField
            id="login-email"
            label={intl.formatMessage(sharedMessages.email)}
            name="username"
            required
            mb={4}
            disabled={isLoggingIn}
            noValidate
          />

          <InputField
            id="login-password"
            label={intl.formatMessage(m.passwordInputLabel)}
            name="password"
            required
            type="password"
            mb={4}
            disabled={isLoggingIn}
          />

          <Button
            variant="blue"
            type="submit"
            loading={isLoggingIn}
            width="100%"
          >
            <T {...m.loginButton} />
          </Button>
        </Form>
      </div>
    </>
  );
};

export default LoginForm;
